export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const LOCAL_STORAGE_KEY = 'gpt-muse';
export const EXAMPLE_FORM_ID_CAPTCHA = import.meta.env.VITE_EXAMPLE_FORM_ID_CAPTCHA;
export const EXAMPLE_FORM_ID = import.meta.env.VITE_EXAMPLE_FORM_ID;
export const STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
export const RUSTY_TOOLS_BASE_URL = 'https://blog.gpt-muse.com';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development'
export const IS_DEVELOPMENT = SENTRY_ENVIRONMENT === 'development';